module.exports = __webpack_public_path__ + "img/Erp_logo@2x.f29df923.png";